import styled from 'styled-components';

// Images
import TwitterLogoSource from '../../../images/twitter.svg';

const TwitterLogo = styled(TwitterLogoSource)`
  max-width: 100%;
  height: auto;

  path {
    fill: var(--colors-mischka);
    fill-opacity: 0.7;
  }
`;

export default TwitterLogo;
